import React, { memo } from 'react'
import { makeStyles } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Skeleton from 'transfix-ui/core/Skeleton'

const useMarketInsightsLocationDataSkeletonStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}))

export const MarketInsightsLocationDataSkeleton = memo(() => {
  const classes = useMarketInsightsLocationDataSkeletonStyles()
  return (
    <Box className={classes.container}>
      <Skeleton width='146px' height='27px' variant='rectangular' />
      <Skeleton width='105px' height='42px' variant='rectangular' />
      <Skeleton width='73px' height='15px' variant='rectangular' />
    </Box>
  )
})

export default MarketInsightsLocationDataSkeleton
